import Component from 'inferno-component';
import FlashcardIcon from '../assets/images/decks-icon';

class FlashCardWarning extends Component {
  render() {
    return (
      <div className="flashcard__warning">
        <div className="flashcard__flashcard-icon">
          <FlashcardIcon/>
        </div>
        <h2 className="section__title">
          Almost there!<br/>
          To start using flashcards you'll need to create an account first
        </h2>
        <p>By creating an account, you'll be able to</p>
        <ul>
          <li>&ndash; Create flashcard decks</li>
          <li>&ndash; Save important words</li>
        </ul>
        <a className="button" href="/register">Create a new account</a>
        <a className="link link--secondary" href="/login"> Already have an account? Log in &rarr;</a>
      </div>
    );
  }
}

export default FlashCardWarning;



// WEBPACK FOOTER //
// ./src/components/FlashCardWarning.js